import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS } from "@tCentro/theme/design";
import parse from "html-react-parser";

import React from "react";
import { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    heading = "heading",
    description = "description",
    textColor = "textColor",
    enterLink = "enterLink",
    linkLabel = "linkLabel",
    hideOnLogin = "hideOnLogin",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.heading]: string;
        [fields.textColor]: string;
        [fields.enterLink]: LinkFieldValue;
        [fields.linkLabel]: string;
        [fields.description]: string;
        [fields.hideOnLogin]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    session: getSession(state),
});

export interface CENReRegisterBannerStyle {
    container?: InjectableCss;
    textLinkStyles?: LinkPresentationProps;
    closeButtonStyles?: IconPresentationProps;
    contentStyles?: TypographyProps;
    headingStyles?: InjectableCss;
    leftContentStyles?: InjectableCss;
    rightContentStyles?: InjectableCss;
}

export const cenReRegisterBannerStyle: CENReRegisterBannerStyle = {
    leftContentStyles: {
        css: css`
            display: flex;
            align-items: center;
            max-width: 80%;
            
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                ])}
            @media (min-width: 993px) and (max-width: 1200px) {
                flex-direction: column;
            }
        `,
    },
    rightContentStyles: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    headingStyles: {
        css: css`
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 24px;
                    `,
                    css`
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 24px;
                    `,
                    css`
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 24px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    container: {
        css: css`
            display: flex;
            position: relative;
            justify-content: space-between;
            align-items: center;
            max-width: 1800px;
            margin-right: auto;
            margin-left: auto;
            width: 100%;
            height: auto;
            padding: 16px 45px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                       
                        css`
                            padding-left: 20px;
                            padding-right: 30px;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        `,
                      
                        css`
                            padding-left: 30px;
                            padding-right: 30px;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        `,
                        css`
                            padding-left: 45px;
                            padding-right: 30px;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            @media (min-width: 993px) and (max-width: 1200px) {
                padding: 16px 0px !important;
                flex-direction: column !important;
                align-items: center !important;
                justify-content: center !important;
            }
        `,
    },
    contentStyles: {
        css: css`
            margin-left: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 8px 0px 16px 0px;
                        max-width: 100%;
                    `,
                    css`
                        margin: 8px 0px 16px 0px;
                        max-width: 100%;
                    `,
                    css`
                        margin: 8px 0px 16px 0px;
                        max-width: 100%;
                    `,
                    null,
                    null,
                ])}
            @media (min-width: 993px) and (max-width: 1200px) {
                margin: 8px 0px 16px 0px;
                max-width: 100%;
            }
            p {
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px;
                text-align: center;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 16px;
                        `,
                        css`
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 16px;
                        `,
                        css`
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 16px;
                        `,
                        null,
                        null,
                    ])}
            }
        `,
    },
    textLinkStyles: {
        color: "#8F0446",
        css: css`
            background: ${COLORS.white};
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 16px;
            margin-right: 16px;
            padding: 8px 16px;
            border-radius: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 0px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 16px;
                    `,
                    css`
                        margin-left: 0px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 16px;
                    `,
                    css`
                        margin-left: 0px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 16px;
                    `,
                    null,
                    null,
                ])}
            @media (min-width: 993px) and (max-width: 1200px) {
                margin-left: 0px !important;
            }
        `,
    },
    closeButtonStyles: {
        color: "white",
        size: 32,
        css: css`
            background: none;
            cursor: pointer;
            border: none;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: absolute;
                            top: 0px;
                            right: 0px;
                        `,
                        css`
                            position: absolute;
                            top: 0px;
                            right: 0px;
                        `,
                        css`
                            position: absolute;
                            top: 0px;
                            right: 0px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
            &:hover {
                background: none !important;
            }
            @media (min-width: 993px) and (max-width: 1200px) {
                position: absolute;
                top: 16px;
                right: 16px;
            }
        `,
    },
};

const mapDispatchToProps = {};

const styles = cenReRegisterBannerStyle;

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const CENReRegisterBanner: FC<Props> = ({ fields, session }) => {
    const [isClose, setIsClose] = useState(false);

    if (fields.hideOnLogin) {
        const isLoggedIn = (session.isAuthenticated || session.rememberMe) && !session.isGuest;
        if (isLoggedIn) {
            return null;
        }
    }

    const closeHandler = () => {
        setIsClose(true);
    };

    const enteredLink = useGetLink(fields.enterLink);

    const bookAmtContainer = {
        css: css`
            background: linear-gradient(90deg, #8f0446 0%, #1d2d36 100%);
            color: ${fields.textColor};
            position: relative;
        `,
    };

    const notActiveContainer = {
        css: css`
            display: none;
        `,
    };

    return (
        <StyledWrapper {...(isClose === true ? { ...notActiveContainer } : { ...bookAmtContainer })}>
            <StyledWrapper {...styles.container}>
                <StyledWrapper {...styles.leftContentStyles}>
                    <Typography as="span" {...styles.headingStyles}>
                        {fields.heading}
                    </Typography>
                    <Typography as="p" {...styles.contentStyles}>
                        {parse(transformContentHtml(fields.description), parserOptions)}
                    </Typography>
                </StyledWrapper>

                <StyledWrapper {...styles.rightContentStyles}>
                    <Link href={enteredLink.url} {...styles.textLinkStyles}>
                        {fields.linkLabel}
                    </Link>

                    <Icon
                        onClick={closeHandler}
                        data-test-selector="Close Button"
                        aria-label="Close Button"
                        src={X}
                        {...styles.closeButtonStyles}
                    ></Icon>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CENReRegisterBanner),
    definition: {
        group: "Basic",
        displayName: "CEN RERegister Banner",
        fieldDefinitions: [
            {
                name: fields.textColor,
                displayName: "Text Color",
                editorTemplate: "ColorPickerField",
                defaultValue: "#FFF",
                fieldType: "General",
            },
            {
                name: fields.heading,
                displayName: " Add  Heading",
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.description,
                displayName: "Add Description",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "General",
            },

            {
                name: fields.enterLink,
                displayName: "Text Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
            },
            {
                name: fields.linkLabel,
                displayName: "Link Label",
                editorTemplate: "TextField",
                defaultValue: "Register Now",
                fieldType: "General",
            },
            {
                name: fields.hideOnLogin,
                displayName: "Hide On Login",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
